import { render } from "./VerticalLayoutRenderer.vue?vue&type=template&id=2cc5eec6&ts=true"
import script from "./VerticalLayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./VerticalLayoutRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__